export function getBrowserVisibilityPropEventType(document) {
    if (typeof document.hidden !== "undefined") {
        // Opera 12.10 and Firefox 18 and later support
        return "visibilitychange";
    }
    else if (typeof document.msHidden !== "undefined") {
        return "msvisibilitychange";
    }
    else if (typeof document.webkitHidden !== "undefined") {
        return "webkitvisibilitychange";
    }
}
export function getBrowserDocumentHiddenProp(document) {
    if (typeof document.hidden !== "undefined") {
        return document.hidden;
    }
    else if (typeof document.msHidden !== "undefined") {
        return document.msHidden;
    }
    else if (typeof document.webkitHidden !== "undefined") {
        return document.webkitHidden;
    }
}
// export function getIsDocumentHidden() {
//   return getBrowserDocumentHiddenProp(document);
// }
